import React from "react";

const ReportingIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 24 24"
      fill="none"
      className="study-list-report-icons"
    >
      <path
        d="M2.93384 8.5H13.9338V10.5H2.93384V8.5ZM2.93384 6.5H13.9338V4.5H2.93384V6.5ZM2.93384 14.5H9.93384V12.5H2.93384V14.5ZM17.9438 11.37L18.6538 10.66C19.0438 10.27 19.6738 10.27 20.0638 10.66L20.7738 11.37C21.1638 11.76 21.1638 12.39 20.7738 12.78L20.0638 13.49L17.9438 11.37ZM17.2338 12.08L11.9338 17.38V19.5H14.0538L19.3538 14.2L17.2338 12.08Z"
        // fill={(props.active != undefined && props.active != null && props.active == true) ?"rgb(20 123 255)":"#DADADA"}
      />
    </svg>
  );
};

export default ReportingIcon;
